module.exports = __webpack_public_path__ + "static/avenir-regular-d074ce088ea67a38314516d77892a66d.woff";